export default function AlreadyTaken() {
    return (
        <div className="error alreadyTaken">
            <h1>Assessment has already been completed</h1>
            <img src="/media/alreadyTaken.jpg" alt="Already Taken" />
        </div>
    );
}
